<script lang="ts" setup>
import TextCardHeader from '~/components/TextCardHeader.vue'
export interface TextCard {
  title: string
  highlights: {
    title: string
    url: string
  }[]
  cta: {
    title: string
    url: string
  }
}

defineProps<TextCard>()
</script>

<template>
  <div class="text-card">
    <TextCardHeader :title="title" />

    <ul class="text-card__highlights">
      <li
        v-for="highlight in highlights"
        :key="highlight.title"
      >
        <div class="text-card__icon-container">
          <img
            src="/icons/chevron-right.svg"
            alt=""
            width="7"
          >
        </div>
        <NuxtLink :to="$url(highlight.url)">
          {{ highlight.title }}
        </NuxtLink>
      </li>
    </ul>

    <NuxtLink
      :to="$url(cta.url)"
      class="text-card__cta"
    >
      {{ cta.title }}
    </NuxtLink>
  </div>
</template>

<style scoped>
.text-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: var(--gray-lighter);
}

.text-card__icon-container {
  width: var(--spacing-m);
  display: grid;
  place-items: center;
}

.text-card__highlights {
  display: block;
  flex-grow: 1;
  padding-inline: var(--spacing-m);
  padding-bottom: var(--spacing-s);
}

.text-card__highlights li {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-block: var(--spacing-xs);
}

.text-card__cta {
  display: block;
  padding: var(--spacing-s) var(--spacing-m);
  background-color: var(--gray-light);
}
</style>
